import { useAppDispatch } from "@app/hooks"
import GenericDialog from "@cmp/genericDialog"
import { archiveCourse } from "@features/coursesMenu/coursesMenuSlice"
import { popupClosed } from "@features/ui/uiSlice"
import { parseStringVersion } from "@utils/versionUtils"

function ArchiveCourseConfirmationPopup(props: {
  courseId: string
  version: string
  onClose: () => void
}) {
  const dispatch = useAppDispatch()
  const { courseId, version } = props
  const { major: majorVersion } = parseStringVersion(version)
  const onArchive = () => {
    dispatch(popupClosed())
    dispatch(archiveCourse({ courseId, majorVersion }))
  }
  const { onClose } = props

  return (
    <GenericDialog
      open
      onClose={onClose}
      size="xs"
      title="Archive this course?"
      subtitle={
        "The course will no longer be visible to all users in the main" +
        "repository. You can restore it at any time."
      }
      buttons={[
        {
          type: "secondary",
          text: "Cancel",
          onClick: onClose,
        },
        {
          type: "primary",
          text: "Archive",
          onClick: onArchive,
        },
      ]}
    />
  )
}

export default ArchiveCourseConfirmationPopup
